import { MantineTextInput } from '@dealstack/frontend/shared/components/mantineForm/MantineTextInput.tsx';
import { InlineLoader } from '@dealstack/frontend/shared/components/loaders/InlineLoader/InlineLoader.tsx';
import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { Button, Flex } from '@mantine/core';
import { FormProvider } from 'react-hook-form';
import { TEST_ELEMENT_IDS } from '@dealstack/frontend/shared/helper/UIElementIdentifier/UIElementIdentifier.tsx';
import {
	CREATE_PERSON_NATURAL_FORM_VALUES,
	useCreatePersonNaturalController,
} from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/CapManageSidebar/CreatePersonTabs/CreatePersonNatural/useCreatePersonNaturalController.ts';

interface Props {
	onCreateSuccess: (createdEntityId: string, withClose?: boolean) => void;
	dealId: string;
	setComputedName: (value: string) => void;
}

export const CreatePersonNatural = ({ onCreateSuccess, dealId, setComputedName }: Props) => {
	const { createPersonNaturalForm, onSubmit, isLoading } = useCreatePersonNaturalController(
		onCreateSuccess,
		dealId,
		setComputedName
	);
	const tCapManage = useTranslationCapManage();

	const handleSubmitAndClose = createPersonNaturalForm.handleSubmit((data) =>
		onSubmit(data, false)
	);

	const handleSubmitAndReset = createPersonNaturalForm.handleSubmit((data) =>
		onSubmit(data, true)
	);

	return (
		<FormProvider {...createPersonNaturalForm}>
			{isLoading && <InlineLoader />}
			<form onSubmit={handleSubmitAndClose}>
				<MantineTextInput
					data-testid={
						TEST_ELEMENT_IDS.CAP_DEAL_DIRECTORY_CREATE_NATURAL_PERSON_FIRST_NAME_INPUT
					}
					autoFocus
					size="md"
					placeholder={tCapManage(
						'sidebar.create_entity_box.natural_person_form.first_name_label'
					)}
					name={CREATE_PERSON_NATURAL_FORM_VALUES.FIRST_NAME}
				/>

				<MantineTextInput
					data-testid={
						TEST_ELEMENT_IDS.CAP_DEAL_DIRECTORY_CREATE_NATURAL_PERSON_LAST_NAME_INPUT
					}
					size="md"
					placeholder={tCapManage(
						'sidebar.create_entity_box.natural_person_form.last_name_label'
					)}
					name={CREATE_PERSON_NATURAL_FORM_VALUES.LAST_NAME}
				/>

				<Flex gap="0.5rem" mt="1rem">
					<Button
						data-testid={
							TEST_ELEMENT_IDS.CAP_DEAL_DIRECTORY_CREATE_NATURAL_PERSON_SUBMIT_BUTTON
						}
						size="md"
						type="submit"
						style={{ flex: 1 }}
					>
						{tCapManage(
							'sidebar.create_entity_box.natural_person_form.submit_button_text'
						)}
					</Button>
					<Button variant="default" style={{ flex: 1 }} onClick={handleSubmitAndReset}>
						{tCapManage(
							'sidebar.create_entity_box.organisation_form.add_another_button_text'
						)}
					</Button>
				</Flex>
			</form>
		</FormProvider>
	);
};
